<template>
    <div class="">
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" size="2" icon="cart-arrow-down"></vue-fontawesome>
            Orders
        </h1>

        <section>    
            <div class="d-flex justify-content-between">
                <div>
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Orders
                            </a>
                        </li>                               							
                    </ul>
                </div>            
            </div>	
            <div class="d-flex justify-content-between mb-5">
                <!-- right -->
                <section class="d-flex justify-content-between w-100">
                    <div class="d-flex">
                        <span class="p-2 font-weight-bold" v-if="orders">
                            <span class="text-muted">Found</span> {{orders.length}}
                        </span>
                        <div class="dropdown">
                            <a class="btn btn-light dropdown-toggle" 
                                href="#" role="button" id="dropdownMenuLink" 
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Filters
                                <vue-fontawesome class="mr-2" icon="filter"></vue-fontawesome>	
                            </a>                        
                            <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                    <div class="form-group d-flex justify-content-between">
                                        <label class="p-2">Search</label>
                                        <input type="text" class="col-8 form-control" v-model="search"> 
                                    </div> 
                                    <div class="form-group d-flex justify-content-between">
                                        <label >Since</label>
                                        <select class="col-8 form-control" v-model="date_range">
                                            <option value=1>today</option>
                                            <option value=2>yesterday</option>
                                            <option value=7>last 7 days</option>
                                            <option value=14>last 14 days</option>
                                            <option value=30>last 30 days</option>
                                            <option value=90>last 3 months</option>
                                        </select>
                                    </div>														
                                    <div class="form-group d-flex justify-content-between">
                                        <label class="p-2">From</label>
                                        <input type="date" name="bday" max="3000-12-31" 
                                        min="1000-01-01" class="col-8 form-control" v-model="from_date"> 
                                    </div> 
                                    <div class="form-group d-flex justify-content-between">
                                        <label class="p-2">To</label>
                                        <input type="date" name="bday" max="3000-12-31" 
                                        min="1000-01-01" class="col-8 form-control" v-model="to_date"> 
                                    </div> 
                                    <div class="ml-2 d-flex justify-content-end">
                                        <button class="btn btn-outline-success"  @click="getOrders()">Get Orders</button>
                                    </div>	
                            </div>
                        </div>
                        <div class="ml-2">
                            <button class="btn btn-outline-success border-0"
                                @click="$exportTable('ordersTable','orders.csv')">
                                <vue-fontawesome class="mr-2" icon="file-excel-o"></vue-fontawesome>
                                Export
                            </button>	
                        </div>
                    </div>       
                    <div>
                        <button class="btn btn-success" data-toggle="modal" data-target="#addOrderModal">
                            add Order
                        </button>
                    </div>             	
                </section>                           																							
            </div>
            <div class="tab-pane fade show active border border-0 rounded shadow p-2" 
                id="pills-home" 
                role="tabpanel"                 
                aria-labelledby="pills-home-tab">                
                <table class="table table-borderless table-responsive-sm" id="ordersTable">
                    <thead >
                        <tr>
                        <th scope="col">State</th>
                        <th scope="col">ID</th>
                        <th scope="col">Customer</th>
                        <th scope="col">Placed on</th>
                        <th scope="col">Date of delivery</th>
                        <th scope="col">Total Items</th>                        
                        <th scope="col"></th>
                        </tr>
                    </thead>                    
                    <tbody v-if="orders && orders.length">
                        <tr v-for = "(order,index) in orders" :key="index">                            
                            <td>
                                <span class="badge badge-pill badge-danger"
                                    v-if="order.state === 'new'">
                                    {{order.state}}    
                                </span>
                                <span class="badge badge-pill badge-light"
                                    v-if="order.state === 'fulfilled'">
                                    {{order.state}}    
                                </span>
                            </td> 
                            <td>{{order.id}}</td>
                            <td>{{order.customer_id.name}}</td>
                            <td>{{order.placed_on | dateformat}}</td>
                            <td>{{order.date_of_delivery | dateformat}}</td>
                            <td>{{order.items.length}}</td>                                                       
                            <div class="p-3">
                                <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Actions
                                </a>
                                <span class="dropdown-menu">                                                                        
                                    <a class="dropdown-item cursor-pointer" 
                                        @click="openReceipt(order)">
                                        view order
                                    </a>                                                                   									
                                </span>
                            </div>                            
                        </tr>                   
                    </tbody>
                </table> 
                <div class="p-3 d-flex justify-content-center"
                    v-if="orders && ! orders.length">
                    <span class="p-2">No records to show since</span>
                    <div class="form-group d-flex justify-content-between">								
                        <select class="form-control" v-model="date_range">
                            <option value=1>today</option>
                            <option value=2>yesterday</option>
                            <option value=7>last 7 days</option>
                            <option value=14>last 14 days</option>
                            <option value=30>last 30 days</option>
                            <option value=90>last 3 months</option>
                        </select>
                    </div>	
                </div>
                <div class="p-3 d-flex justify-content-center"
                    v-if="! orders">
                    <div class="spinner-border p-3 m-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>		               
            </div>
        </section>
        <!-- Button trigger modal -->
        <button type="button" id="receipt-modal-button" class="d-none btn" data-toggle="modal" data-target="#ReceiptModal">
            Launch receipt modal
        </button>
        
        <!--receipt Modal -->
        <div class="modal fade" id="ReceiptModal" tabindex="-1" role="dialog" aria-labelledby="ReceiptModal" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content" v-if="receipt_modal_data">
                <div class="modal-header">
                <h5 class="modal-title font-weight-bold" >ID. {{receipt_modal_data.id}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body" style="height: 50vh; overflow-y:scroll">	
                    <div class="d-flex justify-content-center">
                        <span class="badge badge-pill badge-danger"
                            v-if="receipt_modal_data.state === 'new'">
                            {{receipt_modal_data.state}}    
                        </span>
                        <span class="badge badge-pill badge-light"
                            v-if="receipt_modal_data.state === 'fulfilled'">
                            {{receipt_modal_data.state}}    
                        </span>
                    </div>							
                    <div class="">
                        <div class="d-flex flex-column">
                            <label class="font-weight-bold">Placed on</label>
                            <span>
                                {{receipt_modal_data.placed_on | dateformat }}
                                ( {{receipt_modal_data.placed_on | fromNow }} )
                            </span>
                        </div>
                        <div class="mt-2 d-flex flex-column">
                            <label class="font-weight-bold">Delivery date</label>
                            <span>
                                {{receipt_modal_data.date_of_delivery | dateformat}}
                                ( {{receipt_modal_data.date_of_delivery | fromNow }} )
                            </span>
                        </div>
                    </div>   
                    <h2 class="mt-3 text-muted">Items</h2>
                    <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th scope="col">Product</th>
                                    <th scope="col">Variant</th>
                                    <th scope="col">Qty</th>                                   
                                </tr>
                            </thead>																	
                            <tbody>
                                <tr v-for="(item,index) in receipt_modal_data.items" :key="index">                                
                                    <td>{{item.product_name}}</td>
                                    <td>{{item.variant_id}}</td>
                                    <td>{{item.quantity}}</td>                                   
                                </tr>														
                            </tbody>					
                    </table>                 
                </div>
                <div class="modal-footer">
                        <span class="d-flex justify-content-between">
                            <label class="font-weight-bold">Items:</label>
                            <span class="ml-2">{{receipt_modal_data.items.length}}</span>
                        </span>	                       
                </div>
            </div>
            </div>
        </div>

        <!-- add order modal -->         
          <div class="modal fade" id="addOrderModal" tabindex="-1" role="dialog" aria-labelledby="addOrderModal" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header border-0">
                    <h5 class="modal-title" id="exampleModalCenterTitle">                            
                        add Order
                    </h5>
                    <button type="button" id="closeTransferStockModal" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form id="transferStockForm">
                    <div class="modal-body">                    
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                              <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-customer" role="tab" aria-controls="pills-customer" aria-selected="true">Customer</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" id="pills-date-tab" data-toggle="pill" href="#pills-date" role="tab" aria-controls="pills-date" aria-selected="false">Pick up date</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" id="pills-date-tab" data-toggle="pill" href="#pills-items" role="tab" aria-controls="pills-items" aria-selected="false" @click="active_basket = '000001'">Items</a>
                            </li>
                          </ul>
                          <hr>
                          <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-customer" role="tabpanel" aria-labelledby="pills-customer-tab">
                                <div>
                                    <searchCustomer />													
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-date" role="tabpanel" aria-labelledby="pills-date-tab">
                                <div class="d-flex justify-content-center">
                                    <input class="form-control" type="date" v-model="order_fullfillment_date">
                                </div>                                
                            </div>
                            <div class="tab-pane fade d-flex" id="pills-items" role="tabpanel" aria-labelledby="pills-items-tab">
                                <section class="col-lg-6"
                                    style="border-right: 5px solid black;">
                                    <h4>Products</h4>
                                    <div>
                                        <searchProducts context="sales" v-on:productPicked="productPicked"/>
                                    </div>
                                </section>
                                <!-- shopping cart -->
                                <section class="col-lg-6 ">
                                    <h4>Cart</h4>                                                       	
                                    <!-- customer basket tabs content					 -->
                                    <div class="" id="pills-tabContent">								
                                        <div class="" 
                                            v-for="basket in open_baskets" :key="basket.id"
                                            :id="`pills-basket-${basket.id}`"
                                            role="tabpanel" >																																				
                                            <div class="p-2 rounded shadow-sm" style="max-height: 60vh; overflow-y:scroll" id="selectedProducts">
                                                <table class="table table-borderless">
                                                    <thead>
                                                        <tr>																											
                                                        <th scope="col">product</th>
                                                        <th scope="col">quantity</th>
                                                        <th scope="col">price</th>
                                                        <th></th>
                                                        </tr>
                                                    </thead>											
                                                    <tbody v-if="basket.products.length">
                                                        <tr v-for="(product,index) in basket.products" :key="index"												
                                                            :id="`basket-item-${product.id}`">																																
                                                            <td v-if="product.product">
                                                                <div>
                                                                    {{product.product.name}}<br/>
                                                                    <small v-if="product.selection.variant">
                                                                        {{product.selection.variant.variant}} - {{product.selection.variant.value}}
                                                                    </small>
                                                                </div>															
                                                            </td>
                                                            <td v-if="product.product">
                                                                <div>
                                                                    <input type="number" 
                                                                    class="form-control" 
                                                                    style="max-width:70px"
                                                                    v-model="product.selection.quantity">
                                                                </div>															
                                                            </td>
                                                            <td v-if="product.product">
                                                                <div>
                                                                    {{product.selection.price | intcomma}}
                                                                </div>															
                                                            </td>
                                                            <td v-if="product.product">
                                                                <div>
                                                                    <i class="delete-button p-2 cursor-pointer"
                                                                        @click="removeProductFromBasket(index)">
                                                                        &times;
                                                                    </i>	
                                                                </div>														
                                                            </td>
                                                        </tr>																										
                                                    </tbody>
                                                    <div v-else class="p-5 d-flex justify-content-center">
                                                        Nothing added to cart yet
                                                    </div>
                                                </table>	
                                            </div>
                                            <!-- totals -->
                                            <div class="p-4 d-flex justify-content-end">										
                                                <span class="mr-4 mt-2 font-weight-bold">
                                                    {{basket_stats(basket.id).number_of_items}} items |
                                                </span>
                                                <span class="mr-4 mt-2 font-weight-bold">
                                                    totals: Ksh {{basket_stats(basket.id).total |intcomma}}
                                                </span>
                                                <button class="btn btn-success" 
                                                    data-toggle="modal" data-target="#processPaymentModal"
                                                    @click = "openProcessPaymentModal(basket_stats(basket.id))">
                                                    create order
                                                </button>
                                            </div>
                                        </div>							
                                    </div>
                                </section>
                            </div>
                          </div>                                                                                                                                    
                    </div>
                    <div class="modal-footer border-0">                            
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-success"
                            @click="transferStock()">                                                        
                            add Order
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </button>
                    </div>
                </form>                
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import searchProducts from '@/components/searchProducts.vue'
    import searchCustomer from '@/components/searchCustomer.vue'
    export default {
        name: 'orders',
        components: {
            searchProducts,
            searchCustomer
        },
        props: {
            msg: String
        },
        data(){
            return{
                search:null,
                orders:null,
                date_range:0,
                from_date: null,
                to_date: null,
                //receipt modal.                

                //toggle full screen
                customers:null,	
                is_full_screen:false,
                //        
                active_basket: '000001',		
                open_baskets:[
                    {
                        "id": "000001",
                        "customer": "Walk in customer",
                        "products":[],				
                    }
                ],
                receipt_data:null,
                payments: {},
                sale_successful: false,
                adding:false,
                date: this.$moment(),
                //showing receipt.
                receipt_modal_data:null
            }
        },       
        mounted(){
            this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
            this.to_date = this.$moment().format('YYYY-MM-DD')
            this.active_basket = "00001"
            this.getOrders()            
        },
        computed:{     
            account_switched(){
                return this.$store.state.account_switch_count
            }
        },
        watch:{
            account_switched: function(){
                this.getOrders()
            }, 
            date_range: function(){
                if (this.date_range){
                    this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
                    this.to_date = this.$moment().format('YYYY-MM-DD')
                    this.getOrders()
                }
            },
            search:function(){			
                this.$searchTable('ordersTable',this.search)			
            }
        },
        methods:{		
            //get_products
            getOrders: function(){  
                this.orders = null          
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/sale-orders/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },
                    params:{
                        date0: this.from_date,
                        date1: this.to_date
                    },
                }).then((response)=>{
                    this.orders = response.data
                }).catch((err)=>{                    
                    this.$emit('alert',err)
                })
            },
            //open order receipt
            openReceipt: function(sale){
                //create modal data
                this.receipt_modal_data = sale
                //open modal
                var button = document.getElementById('receipt-modal-button')
                button.click()
            },
            //fetch list of customers
            getCustomers: function(){                        
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/customers/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },            
                }).then((response)=>{
                    this.customers = response.data
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },	
            //expand to full screen.
            fullscreen: function(){
                if (! this.is_full_screen){
                    //scroll to bottom
                    window.scrollTo(0,document.body.scrollHeight);
                    this.$emit("closeNav")
                    this.is_full_screen = true
                }		
                else{
                    //sroll to top
                    document.body.scrollTop = 0 // For Safari
                    document.documentElement.scrollTop = 0
                    this.$emit("openNav")
                    this.is_full_screen = false
                }
            },	
            //create a new basket.
            newBasket: function(){
                this.open_baskets.push(
                    {
                        "id": "000001", 
                        "customer": "Walk in customer",
                        "products": [
                            {
                                "id": Math.floor(Date.now() / 1000),
                                "product": null,
                                "quantity": 1
                            }
                        ]
                    },			
                )
            },
            //remove a basket from the list of baskets
            removeBasket: function(id){
                var index = this.open_baskets.findIndex((basket) => basket.id === id)
                this.open_baskets.splice(index,1)
            },	
            //get basket index.
            basket_index: function(id){
                return this.open_baskets.findIndex((basket) => basket.id === id)
            },
            //when user picks a product.
            productPicked:function(selected_product){	
                if(! this.active_basket){
                    alert("No basket selected, select one to add products")
                }
                if(selected_product != null){
                    //selects active basket.
                    var index = this.basket_index(this.active_basket)		
                    var products = this.open_baskets[index].products			         
                    //check if product exists			
                    products.filter((p)=>{		
                        if (p.product == null){
                            //if empty then remove from list                    
                            products.splice(p,1)
                        }								
                    })
                    //generate id for product
                    var id = Math.floor(Date.now())
                    //add product to the top of the list
                    products.push({
                        "id": id,
                        "product":selected_product.product,                
                        "selection": selected_product.selection
                    })			
                    setTimeout(()=>{
                        var el = document.getElementById("selectedProducts")
                        el.scrollTop = el.scrollHeight
                        var tr = document.getElementById(`basket-item-${id}`)
                        tr.classList.add('active')				
                    },100)
                }
                //reset		
                selected_product = null
            },
            removeProductFromBasket:function(index){
                //selects active basket.
                var basket_index = this.basket_index(this.active_basket)
                var products = this.open_baskets[basket_index].products					
                
                products.splice(index,1)			
                    
            },
            basket_stats: function(id){
                var total = 0 
                var number_of_items = 0		
                var index = this.basket_index(id)
                //total
                var products = this.open_baskets[index].products
                for (var i in products){											
                    var product = products[i]
                    if(product.product != null){
                        total += parseInt(product.selection.price) * product.selection.quantity				
                        number_of_items += parseInt(product.selection.quantity)
                    }						
                }
                return {"total":total,"number_of_items":number_of_items}
            },

            //PAYMENTS
            //process payments
            openProcessPaymentModal:function(stats){
                this.receipt_data = stats
            },
            //get the ID of a customer
            getCustomerID(name){
                var customer = this.customers.filter((c)=>{
                    return c.name.toUpperCase() === name.toUpperCase()
                })
                if (customer.length == 0){
                    alert("'walk in customer not found. Add a 'walk in customer' to your customer list")
                }
                else{
                    return customer[0].id
                }		
            },
            //organize sale data for posting to server
            organizeSaleData(){
                var data = {}
                var basket_index = this.basket_index(this.active_basket)
                var basket = this.open_baskets[basket_index]		
                        
                if (basket){
                    //customer.
                    if(basket.customer === "Walk in customer"){
                        data.customerId = this.getCustomerID(basket.customer)
                    }
                    else{
                        data.customerId = basket.customer.id
                    }

                    //products.
                    var products = []
                    for (var p of basket.products){								
                        if (p.selection.variant){
                            products.push({
                                "name":p.product.name,
                                "product_id" : p.product.id,
                                "qty" : p.selection.quantity,
                                "total" : p.selection.price,
                                "variant":p.selection.variant.value
                            })
                        }	
                        else{
                            products.push({
                                "name":p.product.name,
                                "product_id" : p.product.id,
                                "qty" : p.selection.quantity,
                                "total" : p.selection.price,						
                            })
                        }		
                    }
                    data.products = products						

                    //payments.
                    var payments = []
                    if (this.payments.cash_amount){
                        payments.push({	
                            "id": this.$randID(),
                            "type": "c",
                            "amount": this.payments.cash_amount,
                            "transaction_id": "N/A"
                        })
                    }
                    if (this.payments.mpesa_amount){
                        payments.push({			
                            "id": this.$randID(),	
                            "type": "m",
                            "amount": this.payments.mpesa_amount,
                            "transaction_id": this.payments.transaction_id || "not given"
                        })
                    }
                    if (this.payments.credit_amount){
                        payments.push({			
                            "id": this.$randID(),	
                            "type": "cr",
                            "transaction_id": "N/A",
                            "amount": this.payments.credit_amount,
                        })
                    }

                    data.payments = payments			
                }		

                return data
                

            },
            //make sale
            makeSale: function(){		
                this.adding = true
                var organised_data = this.organizeSaleData()
                if (organised_data){
                    this.$http({
                        method: 'post',
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/sale/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },
                        data:{
                            customerSale: {
                                id: this.$randID(),
                                date: this.$moment().format('YYYY-MM-DDTHH:mm:ssZZ'),
                                customerId: organised_data.customerId,
                                orderNumber: "N/A",
                                via: "web",
                                payments: organised_data.payments,
                                products: organised_data.products,
                            },
                            loc_id: JSON.parse(localStorage.getItem('logged_in_user_location_id'))
                        }
                    }).then((response)=>{
                        this.adding = false
                        this.payments = {}
                        this.sale_successful =true
                        this.$store.commit('new_sale')
                        setTimeout(()=>{
                            document.getElementById('closeAddSaleModal').click()
                            this.sale_successful = false
                            this.removeBasket(this.active_basket)
                        },3000)
                        setTimeout(()=>{
                            var response_data = response.data
                            response_data.products = organised_data.products
                            this.openReceipt(response_data)
                        },1000)
                    }).catch((err)=>{
                        this.adding = false
                        alert(err)
                    })
                }
            },
            totalItems: function(products){
                var total = 0
                for (var i in products){				
                    total += parseInt(products[i].qty)
                }
                return total
            },
            totalCost: function(products){
                var total = 0.00
                for (var i in products){				
                    total += parseFloat(products[i].total)
                }
                return total
            },
            totalPayment: function(payments){
                var total = 0.00
                for (var i in payments){
                    total += parseFloat(payments[i].amount)
                }
                return total
            },
            // openReceipt: function(sale){
            //     //create modal data
            //     this.receipt_modal_data = sale
            //     //open modal
            //     var button = document.getElementById('receipt-modal-button')
            //     button.click()
            // },
            //generate receipt.
            generateReceipt: function(){
                var element = document.getElementById('ReceiptModalContent')
                element.print()
            }
        }
    }
    // data class CustomerOrder(var id: String,
    //                      var date_of_delivery:String,var state:String,
    //                      var placed_on:String,var customer_id:String,
    //                      var customer_name:String,
    //                      var narration:String="none",
    //                      var items:List<CustomerOrderItems>)

    // data class CustomerOrderItems(var product_id:String, var variant_id:String,
    //     var quantity:String,var product_name:String):Serializable
</script>
      